export const ON_DESKTOP = '@media (min-width: 429px)';
export const ON_PHONE = '@media (max-width: 428px)';
